import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import PregnancyWeekCard from "@/components/dashboard/PregnancyWeekCard";
import BabyUpdateCard from "@/components/dashboard/BabyUpdateCard";
import PartnerShareCard from "@/components/dashboard/PartnerShareCard";
import KickCounterCard from "@/components/dashboard/KickCounterCard";
import BabyNameGenerator from "@/components/dashboard/BabyNameGenerator";
import MilestoneTimelineCard from "@/components/dashboard/MilestoneTimelineCard";
import PremiumGate from "@/components/PremiumGate";

const PregnancyDashboardSection = ({ wellnessMode }) => (
  <>
    <PregnancyWeekCard
      startDate={wellnessMode.pregnancy_start_date}
      dueDate={wellnessMode.pregnancy_due_date}
    />
    <BabyUpdateCard />
    <PartnerShareCard mode="pregnancy" />
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <PremiumGate
        feature="Kick Counter"
        description="Track baby's daily kicks and monitor activity patterns through trimester 3."
      >
        <KickCounterCard />
      </PremiumGate>
      <PremiumGate
        feature="Baby Names"
        description="AI-curated name ideas with origins & meanings. Save favorites to your shortlist."
      >
        <BabyNameGenerator />
      </PremiumGate>
    </div>
    <PremiumGate
      feature="Pregnancy Milestones"
      description="A beautiful timeline of every milestone — heartbeat, viability, full-term, and more."
    >
      <MilestoneTimelineCard />
    </PremiumGate>
    <Link
      to="/pregnancy/explore"
      data-testid="pregnancy-explorer-link"
      className="block"
    >
      <Card className="glass border-pink-400/20 hover:border-pink-400/40 transition-all cursor-pointer group">
        <CardContent className="p-5 flex items-center justify-between">
          <div>
            <p className="text-pink-200 text-xs uppercase tracking-widest mb-1">Pregnancy Explorer</p>
            <p className="text-white font-medium">Browse all 42 weeks →</p>
          </div>
          <span className="text-3xl group-hover:translate-x-1 transition-transform" aria-hidden>🍼</span>
        </CardContent>
      </Card>
    </Link>
  </>
);

export default PregnancyDashboardSection;
